var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.theToast),expression:"theToast"}],staticClass:"toast"},[_vm._v("\n        "+_vm._s(_vm.msg)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }